module.exports = __webpack_public_path__ + "img/app_store.2928664f.svg";